import { api } from '@/apis';
import { useQuery, useQueryClient } from '@tanstack/react-query';

type Value = {
  value: string;
  label: string;
};

type Option = {
  value: string;
  label: string;
  values?: Value[];
};

export function useOptions(name: string, filter: object = {}) {
  const queryKey = ['options', name, filter];
  const queryClient = useQueryClient();
  const query = useQuery<Option[]>({
    queryKey,
    queryFn: async ({ signal }) => {
      const json = [
        { $match: { name, ...filter } },
        { $project: { _id: false, value: true, label: true, values: true } },
        { $sort: { label: 1 } },
      ];

      return api.post('pipeline/options', { json, signal }).json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60,
  });

  return {
    query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
